"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-plusplus */

var play = false;
var FlexMultipleBanner = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
    _a = props.buttonList,
    buttonList = _a === void 0 ? [] : _a,
    insights = props.insights,
    backgroundUrl = props.backgroundUrl,
    _b = props.backgroundUrlLogo,
    backgroundUrlLogo = _b === void 0 ? [] : _b,
    restProps = __rest(props, ["className", "buttonList", "insights", "backgroundUrl", "backgroundUrlLogo"]);
  var useRefLi = (0, _react.useRef)(null);
  // banner logo img
  var imgRefsImage = (0, _react.useRef)(null);
  var ButRefsImage = (0, _react.useRef)(null);
  // 内容区域
  var insightsRef = (0, _react.useRef)(null);
  var i = 0;
  var currentLi = 0;
  var PreCurrentLi = 0;
  var time = 260;
  var listMap = backgroundUrlLogo;
  var listMapLen = (0, _typeof2["default"])(backgroundUrlLogo) === 'object' && listMap.length;
  var changeLibg = function changeLibg(i) {
    if (useRefLi.current) {
      // @ts-ignore
      useRefLi.current.childNodes[currentLi % listMapLen].childNodes[0].style.transform = "scale(" + 40 / 40 / time * (i || 0) + ",1)";
    }
  };
  var conLog = function conLog() {
    if (play) return;
    i++;
    if (i % time === 0) {
      i = 0;
      PreCurrentLi = currentLi % listMapLen;
      currentLi += 1;
      if (useRefLi.current && imgRefsImage.current && ButRefsImage.current) {
        // @ts-ignore
        imgRefsImage.current.childNodes[currentLi % listMapLen].style.opacity = 1;
        // @ts-ignore
        imgRefsImage.current.childNodes[PreCurrentLi].style.opacity = 0;
        // @ts-ignore
        ButRefsImage.current.childNodes.forEach(function (item, index) {
          if (index === currentLi % listMapLen) {
            item.style.display = 'flex';
          } else {
            item.style.display = 'none';
          }
        });
        // @ts-ignore
        insightsRef.current.childNodes[currentLi % listMapLen].style.display = 'block';
        // @ts-ignore
        insightsRef.current.childNodes[PreCurrentLi].style.display = 'none';
        // @ts-ignore
        useRefLi.current.childNodes[PreCurrentLi].childNodes[0].style.transform = "scale(0,1)";
      }
    }
    changeLibg(i);
    requestAnimationFrame(conLog);
  };
  (0, _react.useEffect)(function () {
    if (listMapLen > 1) {
      conLog();
    }
  }, []);
  var contentChange = function contentChange(imgRefsImage, lockIndex) {
    if (imgRefsImage.current) return;
    imgRefsImage.current.childNodes.forEach(function (item) {
      item.style.opacity = 0;
    });
    if (lockIndex !== undefined) {
      imgRefsImage.current.childNodes[lockIndex].style.opacity = 1;
    }
  };
  var contentChange1 = function contentChange1(imgRefsImage, lockIndex) {
    if (imgRefsImage.current) {
      imgRefsImage.current.childNodes.forEach(function (item) {
        item.style.display = 'none';
      });
    }
    if (lockIndex !== undefined) {
      imgRefsImage.current.childNodes[lockIndex].style.display = 'block';
    }
  };
  var contentChange2 = function contentChange2(imgRefsImage, lockIndex) {
    // @ts-ignore
    imgRefsImage.current.childNodes.forEach(function (item, index) {
      // @ts-ignore
      if (lockIndex === index) {
        item.style.display = 'flex';
      } else {
        item.style.display = 'none';
      }
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    className: (0, _classnames["default"])('multiple-banner', className)
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'multiple-banner-container',
    style: backgroundUrl ? {
      background: "url(" + backgroundUrl + ") center no-repeat ",
      backgroundSize: 'cover'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-banner-container-external'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-banner-container-children'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-banner-container-left-container',
    ref: insightsRef
  }, insights && insights.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      content = _a.content;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      style: index !== 0 ? {
        display: 'none',
        transition: 'all 0.2s ease 0s'
      } : {
        display: 'block',
        transition: 'all 0.2s ease 0s'
      },
      className: 'flex-default-banner-container-left'
    }, /*#__PURE__*/_react["default"].createElement("h1", null, title), /*#__PURE__*/_react["default"].createElement("p", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-default-bg-c-hero-icon-mod-multiple-container",
    ref: imgRefsImage
  }, backgroundUrlLogo.map(function (_listItem, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: index !== 0 ? {
        opacity: 0,
        transition: 'all 0.8s ease 0s'
      } : {
        opacity: 1,
        transition: 'all 0.8s ease 0s'
      },
      key: index,
      className: "flex-default-bg-c-hero-icon-mod-multiple"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        opacity: 1,
        marginLeft: '3px',
        background: "linear-gradient(45deg, #00000000, #ffffff40)",
        borderTopRightRadius: '4px',
        borderTopLeftRadius: '4px'
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      style: {
        width: '16px',
        height: '360px'
      },
      src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/fc520ae371d259c40719c2e58686421516304961378983302.png'
    })), /*#__PURE__*/_react["default"].createElement("img", {
      src: 'https://main.qcloudimg.com/qcintl-cms/154/1624607171297/2a40d8765c1b928aa5544c03aff8a32f.svg'
    }), _listItem.map(function (_item, index) {
      return /*#__PURE__*/_react["default"].createElement("img", {
        style: {},
        key: index,
        src: _listItem[index || 0]
      });
    }), /*#__PURE__*/_react["default"].createElement("img", {
      className: 'last-cover-bg',
      src: 'https://main.qcloudimg.com/qcintl-cms/154/1624607171297/2a40d8765c1b928aa5544c03aff8a32f.svg'
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    ref: ButRefsImage
  }, buttonList.map(function (items, index) {
    var compatibleArr = items || [];
    if (items.length < 3) {
      compatibleArr = items && items.length % 2 ? __spreadArrays(items, new Array(3 - items.length % 3).fill({
        supplement: true
      })) : items;
    }
    // console.log(items,compatibleArr, 'compatibleArrcompatibleArrcompatibleArr');
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: index !== 0 ? {
        display: 'none',
        transition: 'all 0.8s ease 0s'
      } : {
        display: 'flex',
        transition: 'all 0.8s ease 0s'
      },
      key: index,
      className: 'flex-default-banner-container-left-div'
    }, compatibleArr.map(function (item, index) {
      return item.filedVideoList ? ( /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('not-a-style', {
          'flex-default-banner-container-left-div--none': item.supplement
        }),
        key: index,
        onClick: function onClick() {
          (0, _utils.reinitIframe)({
            filedVideoBg: item.filedVideoBg,
            filedVideoList: item.filedVideoList,
            postMessageUrl: item.postMessageUrl
          });
        }
      }, item.label)) : ( /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('', {
          'flex-default-banner-container-left-div--none': item.supplement,
          'bot-tint': item.tintType
        }),
        key: index,
        href: item.href
      }, item.label));
    }));
  })), /*#__PURE__*/_react["default"].createElement("ul", {
    ref: useRefLi,
    className: 'flex-default-banner-container__ul',
    onClick: function onClick(e) {
      if (e.target) {
        var lockIndex_1 = 0;
        var nodeTarget_1 = e.target || {};
        // @ts-ignore
        if (nodeTarget_1.nodeName === 'LI') {
          play = true;
          // console.log(play);
          // @ts-ignore
          useRefLi.current.childNodes.forEach(function (item, index) {
            item.childNodes[0].style.transform = "scale(0,1)";
            if (item === nodeTarget_1) {
              lockIndex_1 = index;
            }
          });
          contentChange(imgRefsImage, lockIndex_1);
          contentChange1(insightsRef, lockIndex_1);
          contentChange2(ButRefsImage, lockIndex_1);
          // @ts-ignore
          nodeTarget_1.childNodes[0].style.transform = "scale(" + 1 + ",1)";
        }
      }
      //
    }
  }, listMap.length > 1 ? listMap.map(function (_item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("span", null));
  }) : null)))));
});
FlexMultipleBanner.displayName = 'TCIFlexMultipleBanner';
var _default = exports["default"] = FlexMultipleBanner;